<template>
  <ftx-dialog
    :dialog="dialog"
    position="standard"
    size="sm cardRadius"
    :maximized="false"
    persistent
  >
    <template v-slot:SimpleContent>
      <div class="installAppContent">
        <q-btn
          unelevated
          no-caps
          round
          color="grey-3"
          text-color="grey-9"
          icon="close"
          size="sm"
          class="absolute-top-right q-mr-sm q-mt-sm"
          v-close-popup
        />
        <div class="installAppTop">
          <AppIcon width="80px" height="80px" />
        </div>
        <div class="installAppText">
          <div class="text-subtitle1 text-weight-bold">
            Install <AppIcon :isImage="false" />?
          </div>
          <div>
            Install this application on your home screen for quick and easy
            access when you're on the go.
          </div>
        </div>
        <div class="installAppBottom">
          Just tap
          <SvgIcon
            color="blue"
            size="24px"
            :icon="
              getClassForInstallDialogue() === 'iosFirefox' ||
              getClassForInstallDialogue() === 'iosOpera'
                ? 'ios-firefox'
                : getClassForInstallDialogue() == 'androidFirefox'
                ? 'more-vert'
                : 'ios-share'
            "
          />
          then
          {{
            getClassForInstallDialogue() == "androidFirefox"
              ? '"Add to Home Screen" or "Install"'
              : '"Add to Home Screen"'
          }}
        </div>
      </div>
    </template>
  </ftx-dialog>
</template>

<script setup>
import { ref } from "vue";
import { Platform } from "quasar";

const dialog = ref("installAppDialog");

function getClassForInstallDialogue() {
  if (Platform?.is?.mobile) {
    if (Platform?.is?.ios) {
      if (Platform?.is?.firefox) return "iosFirefox";
      else if (Platform?.is?.safari) return "iosSafari";
      else if (Platform?.is?.chrome) return "iosChrome";
      else if (Platform?.is?.opera) return "iosOpera";
    } else if (Platform?.is?.android) {
      if (Platform?.is?.firefox) return "androidFirefox";
    }
  }
  return "";
}
</script>

<style lang="scss" scope></style>
